import PropTypes from 'prop-types';

// PropTypes for tooltip HOC props
export const tooltipHOCProps = {
  tooltipPosition: PropTypes.string,
  tooltipInfoRow: PropTypes.object,
  tooltipMediaSrc: PropTypes.string,
};

// Placeholder HOC - not fully implemented
export default function withTooltip(Component) {
  return Component;
}
